import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, useLocation, useParams  } from 'react-router-dom'; // Import Link and useLocation

function LinkTab(props) {
  return (
    <Tab
      component={Link} // Use Link component for routing
      to={props.href} // Use "to" for routing
      aria-current={props.selected && 'page'}
      {...props}
    />
  );
}

LinkTab.propTypes = {
  selected: PropTypes.bool,
};

export default function ViewUserTab() {
  const { id } = useParams(); 
  const location = useLocation(); // Get the current location
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    // Sync the tab value with the current route
    if (location.pathname === '/dashboard') {
      setValue(0);
    } else if (location.pathname === '/Orders') {
      setValue(1);
    } else if (location.pathname === '/wallet-transaction') {
      setValue(2);
    }
  }, [location]); // Re-run effect when location changes

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        aria-label="nav tabs example"
        role="navigation"
        className='tab-section-cls'
      >
        <LinkTab label="Basic"  href={`/users-customer/view/${id}`}/>
        <LinkTab label="Orders" href={`/order/${id}`} />
        <LinkTab label="Wallet Transaction" href={`/wallet-transaction/${id}`} />
      </Tabs>
    </Box>
  );
}
